import { ChevronLeft, ChevronRight } from "lucide-react"
import ScreenReaderOnly from "../../screen-reader-only"

const buttonClassName =
  "relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"

interface Props {
  onClickPrev: () => void
  onClickNext: () => void
  disabledPrev: boolean
  disabledNext: boolean
}

const MobilePagination = ({
  onClickPrev,
  onClickNext,
  disabledPrev,
  disabledNext
}: Props) => (
  <div className="flex-1 flex justify-between sm:hidden">
    <button
      type="button"
      onClick={onClickPrev}
      disabled={disabledPrev}
      className={`${buttonClassName} rounded-l-md`}
    >
      <ScreenReaderOnly>Previous</ScreenReaderOnly>
      <ChevronLeft size={16} aria-hidden="true" />
    </button>
    <button
      type="button"
      onClick={onClickNext}
      disabled={disabledNext}
      className={`${buttonClassName} rounded-r-md`}
    >
      <ScreenReaderOnly>Next</ScreenReaderOnly>
      <ChevronRight size={16} aria-hidden="true" />
    </button>
  </div>
)

export default MobilePagination
